module.exports = __webpack_public_path__ + "img/shiLin4.990d5672.png";